<template>
  <div >
    <div style="display: flex; padding: 3px;padding: 3px;" class="testobianco backgroudlist" >
      <div style="width: 100px">{{ COLNO }}</div>
      <div style="width: 75%">{{ COLALIM }}</div>
    </div>

    <div
      style="display: flex;padding: 2px;"
      v-for="(food, idx) in foodList"
      :key="food.idFood"
      :class="!iseven(idx) ? 'even' : ''"
    >
      <div style="width: 100px">{{ food.idFoodShort }}</div>
      <div style="width: 75%" class="link" @click="gotoFoodComponent(food)">{{ food.description }}</div>
    </div>
  </div>
</template>

<script>
import apiConsts from '@/js/apiConsts';
import { getSTRING } from '@/js/utils';

                                                                            
export default {
  name: "FoodResultComponent",
  props: ["language","foodList"],
  emits: { foodSelect : null },
  data() {
    return {
      TITOLO: '',
      COLNO: '',
      COLALIM: ''
    }
  },
  mounted() {
    this.TITOLO = getSTRING(this.language, "TITOLO" , apiConsts.TITOLOAPP);
    this.COLNO = getSTRING(this.language , "COLNO" , "No.");
    this.COLALIM = getSTRING(this.language , "COLALIM" , "Alimento");
  },
  methods: {
    iseven(num) {
      return num % 2 == 0;
    },
    gotoFoodComponent(food) {
        this.$emit("foodSelect" ,food );
    }
  },
};
</script>


<style scoped>
.even {
  background-color: azure;
}
</style>